import React from "react";
import { connect } from "react-redux";
import { getEmpresas } from "../empresas/EmpresaService";
import "../../styles/Empresa.css";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import InfoUnidad from "./InfoUnidad";
import axios from "axios";
import Cookies from 'universal-cookie';
import Tree from 'react-d3-tree';
import NodoOrganigrama from "./NodoOrganigrama";
import {
  URL,
  getAuthorizationHeader,
} from "../../constans/constants";
import { logout } from "../login/SesionService";
import '../../styles/custom-tree.css'
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import Unidad from "./Unidad";
import { eliminarUnidad } from "./OrganizacionService";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles";

class Organizacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      dialogTitle: "",
      dialogType: "",
      submitText: "",

      agregarUnidad: false,
      agregarMiembro: false,
      mostrarDatosUnidad: false,
      idUnidadSeleccionada: null,

      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "neutral",

      unidades: [],
      cargo: [],
      treeData: {},
      translate: {},
      zoom: 0.8,

      eliminarUnidad: false,
      unidadSeleccionada: null
    };
    this.modalRef = React.createRef();
    this.modalEliminarRef = React.createRef();
  }


  handleDialogAgregarUnidad = (value) => {
    if (!value) {
      this.componentDidMount()
    }
    this.setState({
      agregarUnidad: value
    })
  }

  handleDialogAgregarMiembro = (value, error = false, mensaje = "") => {
    if (!value) {
      this.componentDidMount()
    }
    if (mensaje != "") {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: mensaje,
        mensajeFlashSeverity: error ? "error" : "exito"
      })
    }
    this.setState({
      agregarMiembro: value,
    })
  }

  handleDialogMostrarDatosUnidad = (value, nodo) => {

    this.setState({ mostrarDatosUnidad: value }, () => {
      if (value && nodo && this.modalRef) {
        this.modalRef.cargarDetalles(nodo);
      } else if (value) {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: "No se pudieron obtener los datos de la unidad",
          mensajeFlashSeverity: "error"
        })
      }
    });

  }

  handleEliminarUnidadDesdeHijo = (unidad) => {
    this.setState({
      eliminarUnidad: true,
      unidadSeleccionada: unidad,
    });
  };

  // Método que se ejecuta cuando se confirma la eliminación
  handleConfirmarEliminarUnidad = () => {
    eliminarUnidad(this.state.unidadSeleccionada.id).then((resp) => {
      // cerrar modal y manejar respuesta
      if(!resp.error){
        this.componentDidMount()
      }

      this.setState({
        eliminarUnidad: false,
        mostrarDatosUnidad: false,
        unidadSeleccionada: null,
        mostrarMensajeFlash: true,
        mensajeFlash: resp.mensaje,
        mensajeFlashSeverity: !resp.error ? "exito" : "error",
      });

    });
  };

  // Cerrar modal sin eliminar
  cerrarModalEliminarUnidad = () => {
    this.setState({ eliminarUnidad: false });
  };

  componentDidMount() {
    const cookies = new Cookies();
    const idEmpresa = cookies.get('empresa');
    axios.get(URL + `organizacion/unidades?idEmpresa=${idEmpresa}`, getAuthorizationHeader()).then(
      (res) => {
        if (res.data.error == false && res.data.datos && res.data.datos.length > 0) {
          this.setState({ unidades: res.data.datos });
          const treeData = this.buildOrgChart(res.data.datos)
          this.setState({ treeData: treeData });
        }
      },
      (error) => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      }
    );
    this.setState({ cargo: [{ id: 1, nombre: "Supervisor" }, { id: 2, nombre: "Miembro" }] })
    const dimensions = this.treeContainer.getBoundingClientRect();
    this.setState({
      translate: {
        x: dimensions.width / 2,
        y: dimensions.height / 6
      }
    });

    const { mensajeFlash, mostrarMensajeFlash, mensajeFlashSeverity } = this.props.location?.state || {};

    this.setState({
      mensajeFlash: mensajeFlash || '',
      mostrarMensajeFlash: mostrarMensajeFlash || false,
      mensajeFlashSeverity: mensajeFlashSeverity || 'neutral'
    });

  }

  buildOrgChart(data) {
    const orgChart = {};


    const idMap = new Map();
    for (const node of data) {
      idMap.set(node.id, node);
    }
    const getMemberCount = (nodeId) => {
      let count = 0;
      const children = data.filter(child => child.unidadPadre === nodeId);
      for (const child of children) {
        count++;
        count += getMemberCount(child.id);
      }
      return count;
    };

    const buildTree = (nodeId, nivel = 0) => {
      const node = idMap.get(nodeId);
      const tree = {
        id: node.id,
        name: node.descripcion,
        children: [],
        cantidadMiembros: (node.miembros && Array.isArray(node.miembros)) ? node.miembros.length : 0,
        originalData: node,
        cantidadPadres: nivel
      };


      const children = data.filter(child => child.unidadPadre === nodeId);
      for (const child of children) {
        const childTree = buildTree(child.id, nivel + 1);
        tree.children.push(childTree);
      }

      return tree;
    };

    const rootNode = data.find(node => node.unidadPadre === 0);
    orgChart.name = rootNode.descripcion;
    orgChart.id = rootNode.id;
    orgChart.children = [];
    orgChart.cantidadMiembros = (rootNode.miembros && Array.isArray(rootNode.miembros)) ? rootNode.miembros.length : 0;
    orgChart.originalData = rootNode;

    const children = data.filter(child => child.unidadPadre === rootNode.id);
    for (const child of children) {
      const childTree = buildTree(child.id, 1);
      orgChart.children.push(childTree);
    }

    return orgChart;
  }


  manejarResultado = (resultado) => {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: resultado.mensaje,
      mensajeFlashSeverity: !resultado.error ? "exito" : "error",
    })
  }

  manejarError = (error) => {
    this.setState({
      mensajeFlash: error,
      mostrarMensajeFlash: true,
      mensajeFlashSeverity: 'error'
    })
  }


  zigzagPath({ source, target }) {
    return `M${source.x},${source.y}L${source.x},${(source.y + target.y) / 2} ${target.x},${(source.y + target.y) / 2} ${target.x},${target.y}`;
  }


  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/bandeja/pendientes'}
                breadcrumbs={
                  [
                    { label: 'Organigrama', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> Estructura Organizacional </h1>
                  <p className="page-description"> Aquí puedes definir la estructura y dependencias de la empresa </p>
                </div>
                <div className="head-actions">
                  <button className="btn-medium btn-primary open-dialog" data-dialog="modal-nueva-unidad" onClick={() => this.handleDialogAgregarUnidad(true)}
                  ><span className="material-symbols-outlined">lan</span>Nueva unidad</button>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <div id="treeWrapper" style={{ width: '100%', height: '100vh' }} ref={tc => (this.treeContainer = tc)}>
                <Tree
                  data={this.state.treeData}
                  nodeSize={{ x: 280, y: 180 }}  // Ajustado para nodos 260×130
                  separation={{ siblings: 1.0, nonSiblings: 1.1 }}  // Menos separación
                  nodeSvgShape={{ shape: "none" }}
                  renderCustomNodeElement={(rd3tProps) => (
                    <NodoOrganigrama {...rd3tProps}
                      onNodeClick={(node) => this.handleDialogMostrarDatosUnidad(true, node.originalData)} />
                  )}
                  rootNodeClassName="node__root"
                  branchNodeClassName="node__branch"
                  leafNodeClassName="node__leaf"
                  translate={{ x: 750, y: 100 }}
                  pathFunc={this.zigzagPath}
                  orientation="vertical"

                  zoom={this.state.zoom}
                  transitionDuration={500}
                />
              </div>
            </div>

            <ModalEliminarConDetalles
              ref={(ref) => (this.modalEliminarRef = ref)}
              isOpen={this.state.eliminarUnidad}
              cerrarModal={this.cerrarModalEliminarUnidad}
              onConfirmar={this.handleConfirmarEliminarUnidad}
              elemento={this.state.unidadSeleccionada}
              titulo="unidad"
              detallesAMostrar={[
                { clave: 'descripcion', etiqueta: 'Descripción' },
                { clave: 'unidadPadreDescripcion', etiqueta: 'Unidad Padre' }
              ]}
              mensaje="Esta acción eliminará permanentemente la unidad seleccionada"
              textoBotonAccion="CONFIRMAR ELIMINACIÓN"
            />

            <Unidad
              isOpen={this.state.agregarUnidad}
              cerrarModal={this.handleDialogAgregarUnidad}
              onResultado={this.manejarResultado}
              onError={this.manejarError}
            />

            <InfoUnidad
              ref={(ref) => (this.modalRef = ref)}
              abierto={this.state.mostrarDatosUnidad}
              onEliminarUnidad={this.handleEliminarUnidadDesdeHijo}
              onClose={() => this.handleDialogMostrarDatosUnidad(false)}
            />

            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getEmpresas: (page, size, search) => dispatch(getEmpresas(page, size, search)),
});

const mapStateToProps = (state) => ({
  empresaData: state.empresaData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Organizacion);
